G.BoardJam = function(board) {
  G.BoardLayer.call(this, board, {
    constructor: G.Jam,
    maxHp: 3,
    hpToken: true,
    editorSymbol: "jam",
    collectableType: "jam",
    blockMove: true,
    blockMatch: true,
    stopHitPropagation: true,
  });

  this.decreasedToken = false;

  G.sb("hitJam").add(function(type) {
    this.decreasedToken = true;
  }, this);

  G.sb("actionQueueEmptyAfterMove").add(function() {
    if (!this.decreasedToken) {
      this.spread();
    }
    this.decreasedToken = false;
  }, this);
};

G.BoardJam.prototype = Object.create(G.BoardLayer.prototype);

G.BoardJam.prototype.spread = function() {
  var actions = ["U", "D", "L", "R", "I"];
  var len = this.children.length;
  var iRnd = game.rnd.between(0, len-1);

  for (var i = 0; i < len; i++) {
    var dirt = this.children[(i+iRnd)%len];

    Phaser.ArrayUtils.shuffle(actions);
    for (var actionIndex = 0; actionIndex < actions.length; actionIndex++) {
      var action = actions[actionIndex];

      switch (action) {
        case "U":
          if (this.isSpreadPossible(dirt.cellX, dirt.cellY-1)) {
            this.spreadToken(dirt.cellX, dirt.cellY-1);
            return;
          }
          break;
        case "D": 
          if (this.isSpreadPossible(dirt.cellX, dirt.cellY+1)) {
            this.spreadToken(dirt.cellX, dirt.cellY+1);
            return;
          }
          break;
        case "L": 
          if (this.isSpreadPossible(dirt.cellX-1, dirt.cellY)) {
            this.spreadToken(dirt.cellX-1, dirt.cellY);
            return;
          }
          break;
        case "R": 
          if (this.isSpreadPossible(dirt.cellX+1, dirt.cellY)) {
            this.spreadToken(dirt.cellX+1, dirt.cellY);
            return;
          }
          break;
        case "I": 
          if (dirt.hp < this.config.maxHp) {
            dirt.increaseHp();
            return;
          }
          break;
      }
    }
  }
};

G.BoardJam.prototype.isSpreadPossible = function(cellX,cellY) {
  return this.board.isCellOnBoard(cellX, cellY) && !this.getToken(cellX, cellY);
};

G.BoardJam.prototype.spreadToken = function(cellX, cellY) {
  var token = this.createToken(cellX, cellY, 1);
  // var candy = this.board.removeCandy(cellX, cellY, true);

  game.add.tween(token.scale)
    .from({x: 0, y: 0}, 500, Phaser.Easing.Sinusoidal.Out, true);
};